import React, { Component } from 'react';
const axios = require("axios")

class JuiceApp extends Component {
  constructor(props){
    super(props)
    this.state = {
      list: [],
      type: '',
      term: '',
      keywords: []
    }
    // this.initList = this.initList.bind(this)
    // this.showInfo = this.showInfo.bind(this)
    // this.sort = this.sort.bind(this)
  }
  componentDidMount(){
    axios.post('/api/juice/',{
      action: 'library'
    }).then(res => {
      console.log(res.data)
      this.setState({keywords: res.data})
    }).catch(e => {
    })
  }
  handleChange(e, type){
    let state = this.state
    state[type] = e.target.value
    this.setState(state, () => {
      
    })
  }
  handleSubmit(e){
    let state = this.state
    if (state['type'] && state['term']){
      this.setState({busy: true})
      axios.post('/api/juice/',{
        action: 'search',
        payload: {
          type: state.type,
          phrase: state.term
        }
      }).then(res => {
        // console.log(res.data)
        this.setState({busy: false, list: res.data})
      }).catch(e => {
        this.setState({busy: false})
      })
    }
  }
  handleDone(i){
    let state = this.state
    state.list[i]['is_done'] = !state.list[i]['is_done']
    this.setState({busy: true})
    axios.post('/api/juice/',{
      action: 'save',
      payload: {
        type: state.type,
        phrase: state.term,
        list: state.list
      }
    }).then(res => {
      this.setState({busy: false, list: state.list, keywords: res.data})
    }).catch(e => {
      this.setState({busy: false})
    })
  }
  remove_item(item){
    if (window.confirm('Are you sure, you want to remove!') == true) {
      this.setState({busy: true})
      axios.post('/api/juice/',{
        action: 'delete',
        payload: item
      }).then(res => {
        this.setState({busy: false, keywords: res.data})
      }).catch(e => {
        this.setState({busy: false})
      })
    }
  }
  show_phrase(item){
    let that = this
    this.setState({
      type: item.type,
      term: item.phrase
    }, () => {
      that.handleSubmit()
    })
  }
  render() {
    let state = this.state
    return(
      <div className="juice-app">
        <div className="container">
          <h1 className='l2-heading'>Juice App</h1>
          <header>
            <div className='search-wrapper'>              
              <select onChange={(e) => this.handleChange(e, 'type')} value={state.type}>
                <option value=""></option>
                <option value="article">Articles</option>
                <option value="guide">Guides</option>
                <option value="story">Story Pages</option>
                <option value="blog">Blogs</option>
              </select>
              <input type="text" onChange={(e) => this.handleChange(e, 'term')} placeholder="Key Term" value={state.term}/>
              <button className={`button primary ${state.busy ? 'busy' : ''}`} onClick={this.handleSubmit.bind(this)}>GO</button>
            </div>
          </header>
          <main>
            <div className='left'>
              <h3 className='l4-heading'>Previous Phrase</h3>
              <div className='words'>
                <ul>
                  {
                    state.keywords.length > 0 &&
                    state.keywords.map((item, i) => (
                      <li><button className='btn-remove' onClick={(e) => this.remove_item(item)}>-</button><button onClick={(e) => this.show_phrase(item)}>{item.phrase}</button></li>
                    ))
                  }
                </ul>
              </div>
            </div>
            <div className='right'>              
              <p><strong>Found {state.list.length}</strong></p>
              <div className='list'>
                <table>
                  <thead>
                    <tr>
                      <th>URL</th>
                      <th>Count</th>
                      <th>Update Completion</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      state.list.map((e, i) => (
                        <tr key={i}>
                          <td><a href={e.url} target="_blank">{e.url}</a></td>
                          <td>{e.count}</td>
                          <td><button className={`chkDone ${e.is_done ? 'done' : ''}`} onClick={(e) => this.handleDone(i)}>&nbsp;</button></td>
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </main>
        </div>
        <footer>
          <p>Copyright &copy; 2020. Planview, Inc. All Rights Reserved.</p>
        </footer>
      </div>
    );
  }
}
export default JuiceApp;
